// This file was automatically generated from authentication.schema.d.ts
// and contains types and methods for calling PIE

import * as PIEBridge from '@microsoft/pie.sharedbridge';

export function GetPIEScriptVersion(): number {
    return 0.4;
}

export interface RefreshTokenResponse {
    accessToken: string;
    expiresDur: number;
}

export interface AuthEmailResult {
    email: string;
    successful: boolean;
    wasPreviouslyCompleted: boolean;
    webAccountId: string;
    accessToken: string;
    expiresDurationSecondsSinceZero: number;
    isAad: boolean;
}

export interface ResourceTokenRequestParams {
    userId: string;
    resource: string;
    correlationId: string;
    wwwAuthenticateHeaderValue: string;
    targetTenantId: string;
}

export interface TokenResponse {
    token: string;
    expiresDur: number;
}

export interface GetAccessTokenParams {
    upn: string;
    correlationGuid: string;
}

export interface RefreshAuthTokenParams {
    email: string;
    webAccountId: string;
}

export class JsonPostProcessing {
    public static RefreshTokenResponseValue(json: any): RefreshTokenResponse {
        const value = json as RefreshTokenResponse;
        return value;
    }

    public static AuthEmailResultValue(json: any): AuthEmailResult {
        const value = json as AuthEmailResult;
        return value;
    }

    public static ResourceTokenRequestParamsValue(json: any): ResourceTokenRequestParams {
        const value = json as ResourceTokenRequestParams;
        return value;
    }

    public static TokenResponseValue(json: any): TokenResponse {
        const value = json as TokenResponse;
        return value;
    }

    public static GetAccessTokenParamsValue(json: any): GetAccessTokenParams {
        const value = json as GetAccessTokenParams;
        return value;
    }

    public static RefreshAuthTokenParamsValue(json: any): RefreshAuthTokenParams {
        const value = json as RefreshAuthTokenParams;
        return value;
    }
}

export async function getAccessToken(upn: string, correlationGuid: string): Promise<string> {
    const args = { upn: upn, correlationGuid: correlationGuid } as GetAccessTokenParams;
    return PIEBridge.HostBridge.invokeHost('Authentication.getAccessToken', args, undefined);
}

export async function refreshAuthToken(
    email: string,
    webAccountId: string
): Promise<RefreshTokenResponse> {
    const args = { email: email, webAccountId: webAccountId } as RefreshAuthTokenParams;
    return PIEBridge.HostBridge.invokeHost(
        'Authentication.refreshAuthToken',
        args,
        JsonPostProcessing.RefreshTokenResponseValue
    );
}

export async function getInitialAccountAuthToken(): Promise<AuthEmailResult> {
    return PIEBridge.HostBridge.invokeHost(
        'Authentication.getInitialAccountAuthToken',
        '',
        JsonPostProcessing.AuthEmailResultValue
    );
}

export async function getAuthTokenForNewAccount(email: string): Promise<AuthEmailResult> {
    return PIEBridge.HostBridge.invokeHost(
        'Authentication.getAuthTokenForNewAccount',
        email,
        JsonPostProcessing.AuthEmailResultValue
    );
}

export async function getAccessTokenSilently(
    tokenRequest: ResourceTokenRequestParams
): Promise<TokenResponse> {
    return PIEBridge.HostBridge.invokeHost(
        'Authentication.getAccessTokenSilently',
        tokenRequest,
        JsonPostProcessing.TokenResponseValue
    );
}
